import loadable from '@loadable/component';
import Loading from '../../components/Loader';
import qs from 'query-string';
import { fetchArticles } from '../../actions/articles';
import { fetchFeaturedArticles } from '../../actions/featured-articles';

const Articles = loadable(() => import(/* webpackChunkName: "articles" */ './Container'), {
  fallback: Loading
});

Articles.needs = (props, { dispatch }, query) => {
  const searchQuery: any = {
    page: props.params.page
  };

  if (query) {
    searchQuery.q = query.q;
  } else if (typeof window !== 'undefined') {
    const search = qs.parse(window.location.search);
    searchQuery.q = search.q;
  }

  const promises = [dispatch(fetchArticles({ ...query, ...searchQuery }))];

  // Only get featured articles when there are no search queries
  if (Object.values(searchQuery).every(value => !value)) {
    promises.push(dispatch(fetchFeaturedArticles()));
  }

  return Promise.all(promises);
};

export default Articles;
